import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { DataCancellationModel } from 'app/modules/common/entities/data-cancel-data.model';
import { PageLoaderService } from 'app/modules/common/services/page-loader.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { RegistroService } from 'app/modules/fuse/services/registro.service';

@Component({
    selector: 'app-data-cancel',
    templateUrl: './data-cancel.component.html',
    styleUrls: ['./data-cancel.component.scss'],
    standalone: false
})
export class DataCancelComponent implements OnInit {

    public form: UntypedFormGroup;


    constructor(
        private dialogRef: MatDialogRef<DataCancelComponent>,
        private registroService: RegistroService,
        private pageLoader: PageLoaderService,
        private sharedService: SharedService,
        private fb: UntypedFormBuilder,
    ) { }

    ngOnInit(): void {
        this.initForm();
    }


    /**
     * Initialize form
     */
    private initForm() {
        this.form = this.fb.group({
            empresaId: 1,
            apellidos: [null, Validators.required],
            nombre: [null, Validators.required],
        });
    }


    /**
     * Company drop down changes event handler
     * @param company Selected company data
     */
    public onCompanySelcted(company: { id: string; }) {
        this.form.controls.empresaId.setValue(company.id);
    }


    /**
     * Cancel button click event handler
     */
    public onCancel() {
        this.dialogRef.close();
    }


    /**
     * Accept button event handler
     */
    public async onAccept() {

        // validate
        this.form.markAllAsTouched();
        if (!this.form.valid) return;

        // build model
        const model = this.form.value as DataCancellationModel;

        // cancel data
        this.pageLoader.ShowPageLoader();
        const res = await this.cancelData(model);
        this.pageLoader.HidePageLoader();

        // close dialog if data is cancelled
        if (res) this.onCancel();

    }


    /**
     * Cancel data. Return true if process is succesfull
     */
    private async cancelData(dataCancelModel: DataCancellationModel): Promise<boolean> {
        try {

            const res = await this.registroService.cancelData(dataCancelModel).toPromise();

            if (res.code === 0) {

                if (res.result === null) {
                    this.sharedService.ShowSnackBar("Los datos se han cancelado con éxito");
                    return true;
                } else {
                    this.sharedService.ShowSnackBar(res.result);
                }

            } else {
                console.error(res.message);
                this.sharedService.ShowSnackBar("Lo siento, la cancelación de datos ha fallado");
            }

        } catch (error) {
            console.error(error);
            this.sharedService.ShowSnackBar("Lo siento, la cancelación de datos ha fallado");
        }

        return false;
    }

}
